module.exports = __webpack_public_path__ + "img/109008.b74eed0b.png";